<template>
  <div v-if="type" class="label-box">
    {{ types[this.type] }}
  </div>
</template>

<script>
const types = {
  R: "Recommand"
};

export default {
  props: {
    type: String
  },
  data() {
    return {
      types
    };
  }
};
</script>

<style lang="scss" scoped>
.label-box {
  font-size: $fs-xxs;
  color: white;
  font-weight: 500;
  padding: 4px 8px;
  background: linear-gradient(135deg, #547fff, #7ed1ff);
  border-radius: 6px 0px 6px 0px;
}
</style>
